import { put, select } from 'redux-saga/effects';
import { getGallectionById } from '../selectors';
import { putEntities } from '../../redux/entities/actions';
import type { PapiGallection } from '@wix/da-papi-types';
import { normalizeGallection } from '../../redux/normalizr/helpers';

function* updateGallectionSize(folderId: number, delta: number) {
  const gallection: ReturnType<typeof getGallectionById> = yield select(
    getGallectionById,
    folderId
  );
  if (!gallection) {
    return;
  }

  const updatedGallection: PapiGallection = {
    ...gallection,
    size: gallection.size + delta,
  };

  const entities = normalizeGallection(updatedGallection);
  yield put(putEntities({ entities }));
}

export default updateGallectionSize;
